import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DatepickerValueAccessorDirective, InsDatepickerDirective, NumericValueAccessorDirective, ValidateDirective, ValidateInnerDirective } from '@skylab-angular-shared/ui';

@Component({
    selector: 'skl-exchange-rate-ins',
    templateUrl: './exchange-rate.component-ins.html',
    styles: [`
        :host {
            width: 100%;
        }

        .exchange-rate {
            display: inline-flex;
            flex-wrap: wrap;
            width: inherit;
        }

        .exchange-rate__item {
            display: inline-flex;
            align-items: baseline;
        }

        .exchange-rate__date {
            flex: 1 auto;
        }

        .exchange-rate__text {
            white-space: nowrap;
        }
    `],
    imports: [NumericValueAccessorDirective, FormsModule, ValidateInnerDirective, InsDatepickerDirective, DatepickerValueAccessorDirective, ValidateDirective, TranslatePipe]
})
export class ExchangeRateInsComponent {
    @Input() public validationKey!: string | null | undefined;
    @Input() public unitCurrency!: string;
    @Input() public rateCurrency!: string;
    @Input() public rate!: number;
    @Input() public unit!: number;
    @Input() public date!: Date;

    @Output() public unitChange = new EventEmitter<number>();
    @Output() public rateChange = new EventEmitter<number>();
    @Output() public dateChange = new EventEmitter<Date>();

    @ViewChild('datepicker') private datepicker!: ElementRef<HTMLInsDatepickerElement>;

    public readonly unitPrecision = 0;
    public readonly ratePrecision = 4;

    public constructor (
        private readonly elementRef: ElementRef
    ) {

        elementRef.nativeElement.setPopoverAnchor = (element: HTMLElement) => {
            this.datepicker.nativeElement.setPopoverAnchor(element);
        };
    }

    public ngOnDestroy(): void {
        this.elementRef.nativeElement.setPopoverAnchor = null;
    }

    public onUnitChange(val: number): void {
        this.unit = val;
        this.unitChange.emit(this.unit);
    }

    public onRateChange(val: number): void {
        this.rate = val;
        this.rateChange.emit(this.rate);
    }

    public onDateChange(val: Date): void {
        this.date = val;
        this.dateChange.emit(this.date);
    }
}
